"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _slate = require("slate");
var _helpers = require("../../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialValue = "";
class EditableCell extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      value: (0, _helpers.isValidJson)(this.props.value) ? _slate.Value.fromJSON(JSON.parse(this.props.value)) : initialValue
    });
    _defineProperty(this, "resizeTextArea", elementUniqueId => {
      let elementToResize = window.document.getElementById(elementUniqueId);
      if (elementToResize !== null) {
        if (elementToResize.scrollHeight > elementToResize.clientHeight) {
          elementToResize.style.height = elementToResize.scrollHeight + "px";
        }
      }
    });
  }
  render() {
    let elementUniqueId = `${this.props.name}+${this.props.rowNumber}`;
    if (this.props.name === "valueEnglish" || this.props.name === "valueGerman") {
      return /*#__PURE__*/_react.default.createElement("td", {
        style: {
          minWidth: "10rem",
          maxWidth: "30rem"
        }
      }, /*#__PURE__*/_react.default.createElement("textarea", {
        maxLength: "12000",
        type: "text",
        rows: "1",
        className: "form-control",
        style: {
          overflow: "hidden",
          resize: "both",
          minWidth: "10rem",
          maxWidth: "100%"
        },
        id: elementUniqueId,
        onKeyPress: this.resizeTextArea(elementUniqueId),
        value: this.props.list[this.props.rowNumber][this.props.name],
        onChange: e => this.props.onChange(e, this.props)
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement("td", {
        style: {
          minWidth: "10rem",
          maxWidth: "20rem"
        }
      }, /*#__PURE__*/_react.default.createElement("input", {
        maxLength: "12000",
        type: "text",
        className: "form-control",
        style: {
          display: "inline-block",
          whiteSpace: "nowrap",
          overflow: "hidden"
        },
        onKeyPress: this.resizeTextArea(elementUniqueId),
        id: elementUniqueId,
        value: this.props.list[this.props.rowNumber][this.props.name],
        onChange: e => this.props.onChange(e, this.props)
      }));
    }
  }
}
var _default = exports.default = EditableCell;
module.exports = exports.default;